import type { PlatformProviderKeyProvider, ThinkingLevel } from '../../types.js';
import { modelFixedThinkingPreset } from '../../../../shared-types/src/model-thinking.js';
import {
  presetThinkingAutoFor,
  thinkingLevelsFor,
} from '../../shared/provider-presets.js';

export function manualThinkingLevelOptions(
  provider: PlatformProviderKeyProvider,
  reasoning: boolean,
  modelId?: string
): ThinkingLevel[] {
  const thinkingAuto = (reasoning ? presetThinkingAutoFor(provider) : undefined) ?? {
    strategy: 'unsupported' as const,
    supportedEfforts: ['off'] as const,
  };
  const preset = provider === 'openai' && reasoning ? modelFixedThinkingPreset(modelId) : undefined;
  if (preset) return ['off', 'auto', ...preset.filter(level => level !== 'off')];
  return thinkingLevelsFor({
    reasoning,
    thinkingAuto,
    vision: false,
    documentInput: false,
    toolUse: false,
    streaming: false,
    structuredOutput: false,
    citationStrict: false,
    longContext: false,
  });
}

export function manualThinkingLevelSelection(
  options: ThinkingLevel[],
  stored?: ThinkingLevel[]
): ThinkingLevel[] {
  return stored ? options.filter((level) => stored.includes(level)) : [];
}

export function manualThinkingLevelsSupported(options: ThinkingLevel[]): boolean {
  return options.some((level) => level !== 'off');
}

export function manualThinkingLevelsPayload(
  options: ThinkingLevel[],
  selection: ThinkingLevel[],
  stored?: ThinkingLevel[]
): ThinkingLevel[] | undefined {
  if (selection.length === 0 || !selection.every(level => options.includes(level))) return undefined;
  if (
    stored &&
    stored.length === selection.length &&
    selection.every((level) => stored.includes(level))
  ) {
    return stored;
  }
  return selection;
}
